/** Human-readable product name, rendered by both frontends. */
export const APP_NAME = 'TeenTack';
/** Every path the api exposes lives under this prefix. */
export const API_PREFIX = '/api';
/** Default page size for list endpoints. */
export const DEFAULT_PAGE_SIZE = 20;
/** Hard ceiling a client may request, so one call cannot pull a whole table. */
export const MAX_PAGE_SIZE = 100;
/** Minimum age a Teen may register at, pending jurisdiction config (M16). TODO(Q1). */
export const DEFAULT_MIN_TEEN_AGE = 13;
/** Maximum age at which an account is still treated as a minor. */
export const TEEN_MAX_AGE = 17;
/** OTP shape and limits. [FR-M01.1] */
export const OTP_LENGTH = 6;
export const OTP_MAX_ATTEMPTS = 5;
/** Password policy. [FR-M01.3, FR-M01.8] */
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;
/**
 * Audit actions written to the append-only AuditLog.
 *
 * Kept as string constants rather than a Prisma enum so each module can add its
 * own actions without a schema migration.
 */
export const AuditAction = {
    // M01 — authentication & access control
    USER_REGISTERED: 'USER_REGISTERED',
    OTP_ISSUED: 'OTP_ISSUED',
    OTP_VERIFIED: 'OTP_VERIFIED',
    OTP_FAILED: 'OTP_FAILED',
    LOGIN_SUCCEEDED: 'LOGIN_SUCCEEDED',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGIN_MFA_CHALLENGED: 'LOGIN_MFA_CHALLENGED',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    TOKEN_REFRESHED: 'TOKEN_REFRESHED',
    SESSION_REVOKED: 'SESSION_REVOKED',
    ALL_SESSIONS_REVOKED: 'ALL_SESSIONS_REVOKED',
    PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
    PASSWORD_RESET_COMPLETED: 'PASSWORD_RESET_COMPLETED',
    ADMIN_CREATED: 'ADMIN_CREATED',
    ADMIN_PERMISSIONS_CHANGED: 'ADMIN_PERMISSIONS_CHANGED',
    ADMIN_ROLE_CHANGED: 'ADMIN_ROLE_CHANGED',
    ACCESS_DENIED: 'ACCESS_DENIED',
    // M02 — consent (link created here so registration can record it)
    PARENT_TEEN_LINK_REQUESTED: 'PARENT_TEEN_LINK_REQUESTED',
    PARENT_TEEN_LINK_APPROVED: 'PARENT_TEEN_LINK_APPROVED',
    PARENT_TEEN_LINK_REJECTED: 'PARENT_TEEN_LINK_REJECTED',
    PROFILE_UPDATED: 'PROFILE_UPDATED',
};
/* -------------------------------------------------------------------------- */
/* Localisation — the profile tables default `country` to United States        */
/* -------------------------------------------------------------------------- */
export const DEFAULT_COUNTRY = 'United States';
/** US states + DC, for the address selects on signup and profile. */
export const US_STATES = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
];
/* -------------------------------------------------------------------------- */
/* Vocabulary for the JSON columns on `teens`                                  */
/*                                                                            */
/* `availability` and `work_preferences` are Json in the schema. These lists   */
/* are the agreed keys so the api, web and admin all write the same shape.     */
/* -------------------------------------------------------------------------- */
export const AVAILABILITY_DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const AVAILABILITY_TIME_SLOTS = ['morning', 'afternoon', 'evening'];
/** Mirrors the schema comment on `teens.work_preferences`. */
export const WORK_TYPES = ['one_time', 'ongoing'];
export const WORK_FREQUENCIES = ['weekly', 'biweekly', 'monthly', 'flexible'];
//# sourceMappingURL=constants.js.map